/**
 * Since earthmoving and stabilization licensing has been removed, All features are now available to all users regardless of context.
 * This mixin is kept for backward compatibility but no longer applies licensing restrictions.
 */
const CxOperationContextMixin = {
  computed: {
    earthmovingContext() {
      // Always return true since earthmoving features are now available to all users
      return true;
    },
    stabilizationContext() {
      // Check if this is a stabilization context (non-earthmoving)
      return this.context === 'stabilization';
    },
  },
};

export default CxOperationContextMixin;